export const CUSTOMER_EVENT = {
  ONBOARD_AUTO_LOGIN: {
    event: 'auto-login-success',
    metadata: {
      source: 'AFY_UI_ONBOARD',
    },
  },
};
